<template>
  <svg width="80" height="40" viewBox="0 0 80 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="80" height="40" rx="4" fill="#F8F9FA"/>
    <mask id="path-2-inside-1_13997_26158" fill="white">
      <path d="M8 8H24V18H8V8Z"/>
    </mask>
    <path d="M24 18V17H8V18V19H24V18Z" fill="#8D969E" mask="url(#path-2-inside-1_13997_26158)"/>
    <rect x="12" y="12" width="8" height="2" rx="1" fill="#B4BFCB"/>
    <rect x="30" y="12" width="8" height="2" rx="1" fill="#B4BFCB"/>
    <rect x="48" y="12" width="8" height="2" rx="1" fill="#B4BFCB"/>
    <mask id="path-7-inside-2_13997_26158" fill="white">
      <path d="M8 18H72V32H8V18Z"/>
    </mask>
    <path d="M8 18V18.5H72V18V17.5H8V18Z" fill="#B4BFCB" mask="url(#path-7-inside-2_13997_26158)"/>
    <rect x="10" y="24" width="13" height="2" rx="1" fill="#DEE3E6"/>
    <rect x="10" y="28" width="49" height="2" rx="1" fill="#DEE3E6"/>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
